import assert from 'minimalistic-assert';
function validateNode(node) {
    assert(node?.definition && typeof node.definition === 'object', 'expected "definition"');
}
const compose = (options, ...fns) => {
    return (params) => {
        validateNode(params);
        return fns.reduceRight((value, fn) => {
            return value ? fn(value, options) : value;
        }, params);
    };
};
const preprocessCollection = ({ dependencies, preprocessors, dependenciesById, }) => {
    return preprocessors.reduce((acc, { preprocess }) => {
        return preprocess(acc, { dependenciesById });
    }, dependencies);
};
const preprocess = ({ dependencies, preprocessors }) => {
    const dependenciesById = new Map(dependencies.map((dependency) => [dependency.definition.id, dependency]));
    const collectionPreprocessors = [];
    const nodePreprocessors = [];
    for (const preprocessor of preprocessors) {
        if (preprocessor.type === 'collection') {
            collectionPreprocessors.push(preprocessor);
        }
        else {
            nodePreprocessors.push(preprocessor);
        }
    }
    const transform = compose({ dependenciesById }, ...nodePreprocessors.map((preprocessor) => preprocessor.preprocess));
    return preprocessCollection({
        dependencies,
        preprocessors: collectionPreprocessors,
        dependenciesById,
    })
        .map(transform)
        .filter((node) => !!node)
        .map(({ definition }) => definition);
};
export { default as alias } from './preprocessors/alias.js';
export { default as atomsIdentification } from './preprocessors/atoms-identification.js';
export { default as config } from './preprocessors/config.js';
export { default as debuggerPreprocessor } from './preprocessors/debugger.js';
export { default as devModeAtoms } from './preprocessors/dev-mode-atoms.js';
export { default as logify } from './preprocessors/logify.js';
export { default as namespaceStorage } from './preprocessors/namespace-storage.js';
export { default as namespacedErrorTracking } from './preprocessors/namespaced-error-tracking.js';
export { default as optional } from './preprocessors/optional.js';
export { default as performanceMonitor } from './preprocessors/performance-monitor.js';
export { default as readOnlyAtoms } from './preprocessors/read-only-atoms.js';
export default preprocess;
